import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
`;
